module.exports = __webpack_public_path__ + "static/img/button7.2538dd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button7.png
// module id = W/aF
// module chunks = 4